import styled, { css } from 'styled-components';
import { remCalc, layout, media } from '@prisjakt/ui-base';

const PAGE_MARGIN_BOTTOM = 30;

const headingStyle = css`
  font-size: ${remCalc(22)};
  font-weight: normal;
  margin-bottom: 0px;
  padding: 0 ${layout.pageContent.gutter.rem};

  ${media.smallOnly`
    font-size: ${remCalc(18)};
  `}
`;

export const PageTitle = styled.h1`
  ${headingStyle}
`;

export const SectionTitle = styled.h2`
  ${headingStyle}
`;

export const ParagraphText = styled.p`
  padding: 0 ${layout.pageContent.gutter.rem};
  margin-bottom: ${remCalc(16)};
  a {
    text-decoration: underline;
  }
`;

export const TrackingSettings = styled.div`
  margin-bottom: ${remCalc(PAGE_MARGIN_BOTTOM)};
`;

export const PersonalizationSettings = styled.div`
  margin-bottom: ${remCalc(PAGE_MARGIN_BOTTOM)};
`;

export const PersonalizationInterests = styled.div`
  padding-left: ${layout.pageContent.gutter.rem};
`;

export const PersonalizationDescription = styled.div`
  padding-left: ${layout.pageContent.gutter.rem};
`;
